export class Assignor {
    constructor(
        public assignorId?: number,
        public assignorGuid?: string,
        public personId?: number,
        public personGuid?: string,
        public nickName?: string,
        public document?: string,
        public companyName?: string,
        public tradeName?: string,
        public stateRegistration?: string,
        public municipalRegistration?: string,
        public openingDate?: Date,
        public phone?: string,
        public email?: string,
        public startDate?: Date,
        public finishDate?: Date,
    ) { }
}
